import { fabric as n } from "fabric";
import { createLogoFabricImg as R, createLogoOuterBox as L } from "./index.es393.js";
const b = ({
  iconSize: t,
  text: l
}) => {
  const r = new n.Textbox(l, {
    fill: "#9D9D9D",
    fontFamily: "Open Sans",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: 15,
    lineHeight: t,
    textAlign: "center",
    width: t
  }), m = new n.Rect({
    width: t,
    height: t,
    fill: "transparent",
    strokeWidth: 0
  });
  return r.set({
    top: (t - (r.height || 0)) / 2,
    left: 0
  }), new n.Group([m, r], {
    left: 0,
    top: t / 2,
    originY: "center"
  });
}, A = async ({
  iconSize: t,
  outerboxWidth: l,
  // TODO: _devicePixelRatio logic needs to be dynamically created
  devicePixelRatio: r,
  totalTenantsCount: m,
  logosList: f
}) => {
  const e = [], c = Math.floor(
    (l - t * 5) / 6
  ), g = t + c;
  for (let o = 0; o < f.length; o++) {
    const a = f[o];
    if (a.logoImgBlob) {
      const u = await R({
        logoImgBlob: a.logoImgBlob,
        logoImgURL: a.logoImgURL,
        targetWidth: g,
        targetHeight: g,
        padding: c,
        devicePixelRatio: r
      });
      if (u) {
        const x = L({
          targetWidth: g,
          targetHeight: g,
          outerBoxOption: {
            strokeWidth: 0
          }
        }), { x: w, y: d } = x.getCenterPoint();
        u.set({
          top: d,
          left: w
        }), e.push(new n.Group([x, u]));
      }
    }
    const s = e.length, i = m - s;
    if ((s === 9 || o === f.length - 1) && i > 0) {
      e.push(
        b({
          iconSize: g,
          text: `+${i}`
        })
      );
      break;
    }
    if (e.length === 10)
      break;
  }
  const h = [];
  let p = 0;
  for (let o = 0; o < e.length; o += 5) {
    const a = e.slice(o, o + 5);
    h.push(
      new n.Group(
        a.map((s, i) => (s.set({
          left: i * (t + c)
        }), s)),
        {
          top: p * (t + c),
          left: l / 2,
          originX: "center",
          originY: "center"
        }
      )
    ), p += 1;
  }
  if (h.length !== 0)
    return new n.Group(h);
};
export {
  b as createRemainderTenantTextFabricObj,
  A as createTenantsGroupFabricObj
};
//# sourceMappingURL=index.es395.js.map
